import { ErrorPage } from 'src/components';
import { useTranslation } from 'react-i18next';

const Error500 = () => {
  const { t } = useTranslation('misc');
  return (
    <ErrorPage
      code={500}
      title={t('500.title')}
      description={t('500.description')}
    />
  );
};

export { Error500 };
